module.exports = __webpack_public_path__ + "static/media/asianet-kannada.9120e632.jpeg";